// extracted by mini-css-extract-plugin
export default {"main_container":"style_main_container__YvQdd","btn":"style_btn__+Au-3","deposit_container":"style_deposit_container__PAUYj","title":"style_title__lFkRY"};